var map = {
	"./help.svg": "cd73",
	"./index/12.svg": "b6d7",
	"./index/Pdquick1.svg": "2315",
	"./index/Pdquick2.svg": "fc1c",
	"./index/Pdquick3.svg": "21df",
	"./index/Pdquick4.svg": "421c",
	"./index/Pdquick5.svg": "e0c9",
	"./index/Pdquick6.svg": "e669",
	"./index/WHquick1.svg": "f4a3",
	"./index/WHquick2.svg": "2a5c",
	"./index/WHquick3.svg": "3df8",
	"./index/WHquick4.svg": "b254",
	"./index/menucaigou.svg": "800a",
	"./index/menucangku.svg": "7831",
	"./index/menuindex.svg": "8ee5",
	"./index/menujichu.svg": "f9f7",
	"./index/menushengchan.svg": "bbaa",
	"./index/menuwendang.svg": "4f02",
	"./index/menuzhiliang.svg": "4fc9",
	"./index/production1.svg": "69dd",
	"./index/production2.svg": "3590",
	"./index/production3.svg": "c759",
	"./index/production4.svg": "42cf",
	"./index/purchase2.svg": "f8eb",
	"./index/purchase3.svg": "3c86",
	"./index/quality1.svg": "41e2",
	"./index/quality4.svg": "b850",
	"./index/quanxian.svg": "19c9",
	"./index/tongzhi.svg": "ddeb",
	"./index/warehouse1.svg": "c8da",
	"./index/warehouse2.svg": "91ad",
	"./index/warehouse3.svg": "214f",
	"./index/warehouse4.svg": "7b4e",
	"./index/wuliaochukudan.svg": "cf4b",
	"./index/wuliaorukudan.svg": "09f3",
	"./index/圆角矩形 8 拷贝 8.svg": "2253",
	"./index/民主评议.svg": "3dd9",
	"./index/系统管理(2).svg": "6085"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2906";